import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import Login from "./pages/Login";
import { NavBar, Sidebar, ThemeSettings } from "./components";
import ViewOrderPart from "./components/ViewOrderPart";
// import ViewOrderPayments from "./components/ViewOrderPayments";
import { Overview, UnAuthorized, NotFound, NotAvailable } from "./pages";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useStateContext } from "./contexts/ContextProvider";
import TimeoutUtility from "./contexts/TimeoutUtility";
import ProtectedRoute from "./contexts/ProtectedRoute";

import Parts from "./pages/Part/Parts";
import AddPart from "./pages/Part/AddPart";
import EditPart from "./pages/Part/EditPart";
import ViewPart from "./pages/Part/ViewPart";
import ApprovedPart from "./pages/Part/ApprovedPart";
import PartHistory from "./pages/Part/PartHistory";
import PartUsed from "./pages/Part/PartUsed";
import GpuWb from "./pages/GpuWb/GpuWb";
import ReceiveGpu from "./pages/GpuWb/ReceiveGpu";
import EditGpu from "./pages/GpuWb/EditGpu";
import ReceiveWb from "./pages/GpuWb/ReceiveWb";
import ImportWb from "./pages/GpuWb/ImportWb";
import TestGpu from "./pages/GpuWb/TestGpu";
import CreateAssembly from "./pages/GpuWb/CreateAssembly";
import TestGpuAssembly from "./pages/GpuWb/TestGpuAssembly";
import ShipAssembly from "./pages/GpuWb/ShipAssembly";
import ViewAssembly from "./pages/GpuWb/ViewAssembly";
import GpuWbReport from "./pages/GpuWb/GpuWbReport";
import ViewGpuHistory from "./pages/GpuWb/ViewGpuHistory";
import GpuRMA from "./pages/GpuWb/GpuRMA";
// import BOMs from "./pages/BOM/BOMs";
import AddEditBOM from "./pages/BOM/AddEditBOM";
// import ViewBOM from "./pages/BOM/ViewBOM.jsx";
import Kits from "./pages/Kit/Kits";
import AddEditKit from "./pages/Kit/AddEditKit";
import Serialized from "./pages/Serialized/Serialized";
import AddSerialized from "./pages/Serialized/AddSerialized";
import EditSerialized from "./pages/Serialized/EditSerialized";
import AssignSerialized from "./pages/Serialized/AssignSerialized";
import ViewSerialized from "./pages/Serialized/ViewSerialized";
import Inventory from "./pages/Inventory/Inventory";
// import ViewInventory from "./pages/Inventory/ViewInventory";
import AddInventory from "./pages/Inventory/AddOpeningBal";
import InStock from "./pages/Inventory/In_stock";
import OutStock from "./pages/Inventory/Out_stock";
import TransferStock from "./pages/Inventory/TransferStock";
import Stores from "./pages/Store/Stores";
import AddStore from "./pages/Store/AddStore";
import EditStore from "./pages/Store/EditStore";
import ViewStore from "./pages/Store/ViewStore";
import AddEditCompany from "./pages/Company/AddEditCompany";
import Customers from "./pages/Customer/Customers";
import AddCustomer from "./pages/Customer/AddCustomer";
import EditCustomer from "./pages/Customer/EditCustomer";
import ViewCustomer from "./pages/Customer/ViewCustomer";
import Users from "./pages/User/Users";
import AddUser from "./pages/User/AddUser";
import EditUser from "./pages/User/EditUser";
import ViewUser from "./pages/User/ViewUser";
// import UserActivities from "./pages/User/UserActivities";
import Vendor from "./pages/Vendor/Vendor";
import AddVendor from "./pages/Vendor/AddVendor";
import EditVendor from "./pages/Vendor/EditVendor";
import ViewVendor from "./pages/Vendor/ViewVendor";
import Accounts from "./pages/Account/Account";
import AddAccount from "./pages/Account/AddAccount";
import EditAccount from "./pages/Account/EditAccount";
import ViewAccount from "./pages/Account/ViewAccount";
import Sales from "./pages/Sale/Sales";
import Quotes from "./pages/Quote/Quotes";
import AddSalesOrder from "./pages/Sale/AddSalesOrder";
import EditSalesOrder from "./pages/Sale/EditSalesOrder";
import ViewSalesOrder from "./pages/Sale/ViewSalesOrder";
import BuildSheet from "./pages/Sale/BuildSheet";
import AddEditSaleOrderNote from "./pages/SaleOrderNote/AddEditSaleOrderNote";
// import Shipment from "./pages/Shipment/Shipment";
import Purchase from "./pages/Purchase/Purchase";
import AddPurchaseOrder from "./pages/Purchase/AddPurchaseOrder";
import EditPurchaseOrder from "./pages/Purchase/EditPurchaseOrder";
import ViewPurchaseOrder from "./pages/Purchase/ViewPurchaseOrder";
import ReceiveLog from "./pages/Receive Log/Receive_Log";
// import Report from "./pages/Reports/Report";
import AddQuotation from "./pages/Quote/AddQuotation";
import EditQuotation from "./pages/Quote/EditQuotation";
import ViewQuotation from "./pages/Quote/ViewQuotation";
import ConvertQuote from "./pages/Quote/ConvertQuote";
import Receipt from "./pages/Receipt/Receipt";
import AddReceipt from "./pages/Receipt/AddReceipt";
import EditReceipt from "./pages/Receipt/EditReceipt";
import ViewReceipt from "./pages/Receipt/ViewReceipt";
import Payment from "./pages/Payment/Payment";
import AddPayment from "./pages/Payment/AddPayment";
import EditPayment from "./pages/Payment/EditPayment";
import ViewPayment from "./pages/Payment/ViewPayment";
import Journal from "./pages/Journal/Journal";
import AddJournal from "./pages/Journal/AddJournal";
import EditJournal from "./pages/Journal/EditJournal";
import ViewJournal from "./pages/Journal/ViewJournal";
// import ViewShipment from "./pages/Shipment/ViewShipment";
import ViewReceiveLog from "./pages/Receive Log/ViewReceiveLog";
// import ViewSale from "./pages/Customer/ViewSale";
// import ViewSO from "./pages/Customer/ViewSO";
// import ViewPurchase from "./pages/Vendor/ViewPurchase";
// import ViewPO from "./pages/Vendor/ViewPO";
import Misc from "./pages/Misc/Misc";
import Calendar from "./pages/Calendar";

const App = () => {
  const {
    activeMenu,
    activeProdMenu,
    activePayment,
    themeSettings,
    setThemeSettings,
    currentColor,
    currentMode,
    userPermID,
  } = useStateContext();

  const orderPages = [
    "AddSalesOrder",
    "EditSalesOrder",
    "ViewSalesOrder",
    "BuildSheet",
    "AddQuotation",
    "EditQuotation",
    "ViewQuotation",
    "ConvertQuote",
    "AddPurchaseOrder",
    "EditPurchaseOrder",
    "ViewPurchaseOrder",
    "PullKit",
    "UpdateKit"
  ];
  const noSideBar = orderPages.some(item => window.location.pathname.includes(item))

  useEffect(() => {
    TimeoutUtility.attachEventListeners();
    TimeoutUtility.resetTimeout();
    return () => {
      TimeoutUtility.removeEventListeners();
    };
  }, []);

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route
            path="*"
            element={
              <>
                <div>
                  <div className={currentMode === "Dark" ? "dark" : ""}>
                    <div className="flex realative dark:bg-main-dark-bg">
                      <div
                        className="fixed right-4 bottom-4"
                        style={{ zIndex: "1000" }}
                      >
                        <TooltipComponent content="Settings" position="TopCenter">
                          <button
                            type="button"
                            className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray text-white"
                            onClick={() => setThemeSettings(true)}
                            style={{ background: currentColor, borderRadius: "50%" }}
                          >
                            <FiSettings />
                          </button>
                        </TooltipComponent>
                      </div>
                      {noSideBar ? (
                        <div>
                          {activeProdMenu && (
                            <div className="w-72 fixed sidebar dark:bg-gray bg-white-bg">
                              <ViewOrderPart />
                            </div>
                          )}
                          {/* {activePayment && (
                            <div className="w-72 fixed sidebar dark:bg-gray bg-white-bg">
                              <ViewOrderPayments />
                            </div>
                          )} */}
                        </div>
                      ) : (
                        <div>
                          {activeMenu && (
                            <div className="w-72 fixed sidebar dark:bg-gray bg-white-bg">
                              <Sidebar />
                            </div>
                          )}
                        </div>
                      )}
                      <div
                        className={`dark:bg-main-gray bg-main-bg min-h-screen w-full ${noSideBar
                          ? activeProdMenu || activePayment
                            ? "md:ml-72 div-sidebar-custom"
                            : "flex-2"
                          : activeMenu
                            ? "md:ml-72 div-sidebar-custom"
                            : "flex-2"
                          }`}
                      >
                        {noSideBar ? null : (
                          <div className="fixed md:static bg-main-bg dark:bg-gray navbar w-full">
                            <NavBar />
                          </div>
                        )}
                        <div>
                          {themeSettings && <ThemeSettings />}
                          <Routes>
                            <Route
                              path="/Overview"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Overview />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/UnAuthorized"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <UnAuthorized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/NotAvailable"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <NotAvailable />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Inventory"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Inventory />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Inventory/Add"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddInventory />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/inventory/instock"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <InStock />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/inventory/outstock"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <OutStock />
                                </ProtectedRoute>
                              }
                            />{" "}
                            <Route
                              path="/inventory/TransferStock"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <TransferStock />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/inventory/viewinventory/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewInventory />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/stores"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Stores />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/stores/add"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddStore />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/stores/edit/:Store_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditStore />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/stores/viewStore/:Store_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewStore />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/users/AddEditCompany"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditCompany />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/users/AddEditSaleOrderNote"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditSaleOrderNote />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Parts />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/AddPart"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddPart />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/EditPart/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditPart />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/viewPart/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewPart />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <GpuWb />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ReceiveGpu"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ReceiveGpu />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/EditGpu/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditGpu />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ReceiveWb"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ReceiveWb />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ImportWb"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ImportWb />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/TestGpu/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <TestGpu />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/CreateAssembly"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <CreateAssembly />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/TestGpuAssembly"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <TestGpuAssembly />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ShipAssembly/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ShipAssembly />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ViewAssembly/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewAssembly />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/Report"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <GpuWbReport />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/ViewGpuHistory/:gpu_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewGpuHistory />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/GpuWb/GpuRMA"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <GpuRMA />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/ApprovedPart/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ApprovedPart />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/PartHistory/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <PartHistory />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Part/PartUsed/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <PartUsed />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Kit"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Kits />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Kit/PullKit/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditKit />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Kit/UpdateKit/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditKit />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Serialized"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Serialized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Serialized/AddSerialized"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddSerialized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Serialized/EditSerialized/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditSerialized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Serialized/AssignSerialized/:parent_id?"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AssignSerialized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Serialized/viewSerialized/:p_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewSerialized />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Customer"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Customers />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/customer/addCustomer"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddCustomer />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/customer/editCustomer/:Customer_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditCustomer />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/customer/viewCustomer/:Customer_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewCustomer />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/customer/ViewSale/:Customer_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewSale />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Customer/ViewSale/ViewSO/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewSO />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/Users"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Users />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Users/addUser"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddUser />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Users/editUser/:user_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditUser />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Users/viewUser/:user_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewUser />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/Users/UserActivities"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <UserActivities />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/Vendor"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Vendor />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Vendor/addVendor"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddVendor />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Vendor/EditVendor/:Vendor_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditVendor />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Vendor/ViewVendor/:Vendor_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewVendor />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/Vendor/ViewPurchase/:Vendor_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewPurchase />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Vendor/ViewPurchase/ViewPO/:po_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewPO />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/Account"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Accounts />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/account/addaccount"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddAccount />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/account/editaccount/:Account_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditAccount />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/account/viewaccount/:Account_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewAccount />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/sales"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Sales />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Quotes"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Quotes />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Sales/AddSalesOrder/:store_id?"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddSalesOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/sales/editSalesOrder/:so_ids"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditSalesOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/sales/viewSalesOrder/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewSalesOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/sales/BuildSheet/:so_part_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <BuildSheet />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/sales/Shipment/:so_ids"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Shipment />
                                </ProtectedRoute>
                              }
                            /> */}
                            {/* <Route
                              path="/sales/viewShipment/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewShipment />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/Purchase"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Purchase />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/addPurchaseOrder/:store_id?"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddPurchaseOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/editPurchaseOrder/:po_ids"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditPurchaseOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/viewPurchaseOrder/:po_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewPurchaseOrder />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/Receive/:po_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ReceiveLog />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/viewReceiveLog/:po_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewReceiveLog />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Quotes/addQuotation/:store_id?"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddQuotation />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Quotes/editQuotation/:so_ids"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditQuotation />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Quotes/viewQuotation/:so_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewQuotation />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Quotes/ConvertQuote/:so_ids"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ConvertQuote />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/receipt"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Receipt />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/receipt/AddReceipt"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddReceipt />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/receipt/EditReceipt/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditReceipt />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/receipt/ViewReceipt/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewReceipt />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/payment"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Payment />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/payment/AddPayment"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddPayment />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/payment/EditPayment/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditPayment />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/payment/ViewPayment/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewPayment />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/journal"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Journal />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/journal/AddJournal"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddJournal />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/journal/EditJournal/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <EditJournal />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/journal/ViewJournal/:r_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewJournal />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/Inventory/InventoryStockReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Inventory/InventoryLedgerReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Inventory/ItemProfitLossReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Account/LedgerReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Account/LedgerReport/:account_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Account/LedgerSummaryReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Sales/SalesDetailReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Sales/SalesSummaryReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/PurchaseDetailReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Purchase/PurchaseSummaryReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Overview/SummaryReport"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Report />
                                </ProtectedRoute>
                              }
                            /> */}
                            {/* <Route
                              path="/BOMs"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <BOMs />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/BOMs/AddEditBOM"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditBOM />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/BOMs/AddEditBOM/:bom_id"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <AddEditBOM />
                                </ProtectedRoute>
                              }
                            />
                            {/* <Route
                              path="/BOMs/ViewBOM"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <ViewBOM />
                                </ProtectedRoute>
                              }
                            /> */}
                            <Route
                              path="/Miscellaneous"
                              element={
                                <ProtectedRoute perms={userPermID}>
                                  <Misc />
                                </ProtectedRoute>
                              }
                            />
                            <Route path="*" element={<NotFound />} />
                            <Route
                              path="/OrderCalendar"
                              element={<Calendar />}
                            />
                          </Routes>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
